import React from 'react';
import { observer } from 'mobx-react';
import { Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import WorldPage from '../pages/world';
import ManagePage from '../pages/manage';
import useEnvironment from '../store/models/env/useEnvironment';
import useProfile from '../store/models/profile/useProfile';

function AppRoutes() {
    useEnvironment();
    useProfile();

    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<WorldPage />} />
                <Route path="/world" element={<WorldPage />} />
                <Route path="/manage" element={<ManagePage />} />
            </Route>
        </Routes>
    );
}

export default observer(AppRoutes);
